"use client";

import Flex from "@/shared/components/common/Flex";
import { format, startOfToday } from "date-fns-jalali";
import Typography from "@/shared/components/common/Typography";
import { generateStayDays } from "@/shared/libs/utils";

interface StaydurationProps {
  initialDate?: Date;
  onClick: (input: string) => void;
}

export default function Stayduration({
  onClick,
  initialDate = startOfToday(),
}: StaydurationProps) {
  const dates = generateStayDays(20, initialDate);

  return (
    <Flex className="flex-col max-h-[50vh] overflow-auto rounded-xs!">
      {dates.map((date, x) => (
        <Flex
          className="flex-col border-b py-2 px-2 cursor-pointer hover:bg-muted dark:hover:bg-muted/10 transition-all duration-150 flex gap-3 items-center"
          key={date.getDate()}
          onClick={() => {
            onClick(format(date, "yyyy/MM/dd"));
          }}
        >
          <Flex className="justify-between items-center gap-x-8">
            <Typography className="font-medium">{`${x + 1} شب`}</Typography>
            <Typography className="font-semibold">
              {format(date, "d MMMM")}
            </Typography>
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
}
